import config from "./config";
import apiService from "./apiService";
export default {
  async getIceProjectionInformation(apiModel, fileName) {
    apiModel.fileName = fileName;
    let iceLoanData = `${config.iceApiUrl}`;
    return apiService.post(iceLoanData, apiModel);
  },
};
